import { GETREQUESTOPTIONS, instance } from '../apiService';

export interface FlagDepartment {
    _id: string;
    name: string;
    isTrial: boolean;
    betaFeatures: string[];
}

export interface FlagUser {
    _id: string;
    name: string | null;
    email: string;
    betaFeatures: string[];
}

export interface FlagUsersResult {
    departmentBetaFeatures: string[];
    users: FlagUser[];
}

export const getFlagDepartments = async (): Promise<FlagDepartment[]> => {
    const res = await instance.get(
        '/api/feature-flags/admin/departments',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const setDepartmentFlag = async (
    departmentId: string,
    flag: string,
    enabled: boolean
): Promise<string[]> => {
    const res = await instance.post(
        `/api/feature-flags/admin/departments/${departmentId}`,
        { flag, enabled },
        GETREQUESTOPTIONS()
    );
    return res.data.betaFeatures;
};

export const getFlagUsers = async (): Promise<FlagUsersResult> => {
    const res = await instance.get(
        '/api/feature-flags/users',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const setUserFlag = async (
    userId: string,
    flag: string,
    enabled: boolean
): Promise<string[]> => {
    const res = await instance.post(
        `/api/feature-flags/users/${userId}`,
        { flag, enabled },
        GETREQUESTOPTIONS()
    );
    return res.data.betaFeatures;
};
